import React, { FunctionComponent } from 'react';

import Badge from '@bitcoin-portal/verse-web-components/dist/Badge';
import Body from '@bitcoin-portal/verse-web-components/dist/Body';
import Circle from '@bitcoin-portal/verse-web-components/dist/Icons/Circle';
import Cross from '@bitcoin-portal/verse-web-components/dist/Icons/Cross';
import Tick from '@bitcoin-portal/verse-web-components/dist/Icons/Tick';
import Loader from '@bitcoin-portal/verse-web-components/dist/Loader';
import Title from '@bitcoin-portal/verse-web-components/dist/Title';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { BadgeContainer, StepWrapper } from './styled';

export const Step: FunctionComponent<StepProps> = ({
  approved,
  title,
  loading,
  detailsMessage,
  error,
  errorMessage,
}) => {
  const upNext = !error && !approved && !loading;
  const waiting = !error && !approved && loading;
  const success = !error && approved;
  const showDescription = (error && errorMessage) || detailsMessage;

  return (
    <StepWrapper>
      {upNext && <Circle color={colors.shade30} />}
      {waiting && <Loader />}
      {success && <Tick color={colors.green100} />}
      {error && <Cross color={colors.red100} thick style={{ paddingTop: 5 }} />}
      <div style={{ maxWidth: 370 }}>
        <Title>{title}</Title>
        {showDescription && (
          <Body size="medium" style={{ marginTop: 4, color: colors.shade80 }}>
            {error ? errorMessage : detailsMessage}
          </Body>
        )}
      </div>
      <BadgeContainer>
        {upNext && <Badge design="waiting">Up Next</Badge>}
        {waiting && <Badge design="pending">Waiting</Badge>}
        {success && <Badge design="default">Approved</Badge>}
        {error && <Badge design="error">{error}</Badge>}
      </BadgeContainer>
    </StepWrapper>
  );
};

export default Step;
